<h1 mat-dialog-title class="p-2 text-center">Prelevement P{{SampleTaking.Numero}}</h1>
<div>
    <div class="row row-cols-1 g-0 px-3">
        <mat-form-field class="col">
            <mat-label>Distance berge</mat-label>
            <input matInput placeholder="Distance berge" type="number" [(ngModel)]="SampleTaking.DistanceBerge">
        </mat-form-field>
        <mat-form-field class="col">
            <mat-label>Profondeur</mat-label>
            <input matInput placeholder="Profondeur" type="number" [(ngModel)]="SampleTaking.Profondeur">
        </mat-form-field>
    </div>
    <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
        Annuler
    </button>
    <button appPreventDoubleClick class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()">
        Sauvegarder
    </button>
</div>